import React, { Component, Fragment } from 'react';
import {
    PageListComponent, HeaderListComponent,
    DatePickerComponent,
} from "../../../common/component/Index";
import DEFINE, { PATHS, DATE_TIME_FORMAT } from "../../../../../constants/Define";
import { isEqual, get } from 'lodash';
import * as Func from '../../../../../helpers/functions';
import VoucherRedeemtion from '../../../../../models/VoucherRedeemtion';

import Wrapper from './../../../common/component/Wrapper';
import Button, { ButtonGroup } from './../../../common/component/Button';

import { omit } from 'lodash';
import RedeemtionList from './RedeemtionList';
import moment from 'moment';

import './VoucherRedeemtionReports.less';

let permisionActions = [];
const defaultState = {

};

const CURRENT_DATE_RANGE_ENUM = {
    DATE: [moment.utc().startOf('days'), moment.utc().endOf('days')],
    WEEK: [moment.utc().startOf('isoWeeks'), moment.utc().endOf('days')],
    MONTH: [moment.utc().startOf('months'), moment.utc().endOf('days')],
}

export default class VoucherRedeemtionReports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            filters: {},
        };
        this.redeemtionListRef = React.createRef();
    }

    componentDidMount() {
        this.getReports()
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.VOUCHER_REDEEMTION_REPORT);
    }

    render() {
        const { t, reportState } = this.props;
        const { isFetching, voucherRedeemReport } = reportState;
        return (
            <PageListComponent className="page-redeemtion-report">
                <HeaderListComponent
                    path={this.props.match.path}
                    groupPath={'reports'}
                    titleHeader={t('item.report.redemptionReports')}
                    componentRight={this.renderFilterSection()}
                />
                <Wrapper className="">
                    <RedeemtionList ref={this.redeemtionListRef}
                        data={voucherRedeemReport}
                        loading={isFetching}
                        onTableChange={this.onTableChange}
                        onDetailTableChange={this.onDetailTableChange}
                        onItemExpanded={this.onItemExpanded}
                    />
                </Wrapper>
            </PageListComponent>
        );
    }

    renderFilterSection() {
        const { t, reportState } = this.props;
        const { isFetchingDownload, voucherRedeemReport } = reportState;
        return (
            <Wrapper className="row col-md-12 m-0 p-0 w100-percent">
                <Wrapper className={`col-md-7 m-0 p-0 pr-2 button-section`}>
                    { permisionActions && permisionActions.allowExportFileExcel &&
                    <Button type="primary" onClick={this.onExportExcel}
                        icon="download" loading={isFetchingDownload}
                        title={t(`item.report.exportExcel`)}
                        disabled={!(voucherRedeemReport.voucherRedeemtions && voucherRedeemReport.voucherRedeemtions.length)}
                        className="mr-2"></Button>
                    }
                    <ButtonGroup>
                        <Button type="dashed" onClick={() => this.onSelectDateRange({ fullValue: CURRENT_DATE_RANGE_ENUM.DATE })}>{t(`item.report.currentDate`)}</Button>
                        <Button type="dashed" onClick={() => this.onSelectDateRange({ fullValue: CURRENT_DATE_RANGE_ENUM.WEEK })}>{t(`item.report.currentWeek`)}</Button>
                        <Button type="dashed" onClick={() => this.onSelectDateRange({ fullValue: CURRENT_DATE_RANGE_ENUM.MONTH })}>{t(`item.report.currentMonth`)}</Button>
                    </ButtonGroup>
                </Wrapper>
                <Wrapper className={`col-md-5 m-0 p-0`}>
                    <DatePickerComponent className={`form-control applyDates w100-percent`}
                        hmsComponent={`RangePicker`} format={DATE_TIME_FORMAT.SHORT_DATE}
                        style={{ padding: 0, border: 0 }}
                        onChange={this.onSelectDateRange} name={`applyDates`}
                        placeholder={[t('placeHolderForm.startDate'), t('placeHolderForm.endDate')]}
                        value={[voucherRedeemReport.startDate, voucherRedeemReport.endDate]}
                    />
                </Wrapper>
            </Wrapper>
        )
    }

    getReports = (filters) => {
        if (!filters) filters = this.getCurrentFilters();
        filters = omit(filters, ['totalCount', 'totalPage'])
        this.setState({ filters });
        this.props.getVoucherRedeemtionReport(filters);
    }

    onTableChange = (pagination, filters, sorter) => {
        let currentFilters = this.getCurrentFilters();
        filters = omit({ ...currentFilters, ...filters }, ['pageSize', 'pageIndex']);
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });
        this.props.getVoucherRedeemtionReport(newFilters);
    };

    onSelectDateRange = (data) => {
        const filters = this.getCurrentFilters(['totalCount', 'totalPage'])
        filters.startDate = data.fullValue[0];
        filters.endDate = data.fullValue[1];
        this.collapseAllRow()
        return this.props.getVoucherRedeemtionReport(filters);
    }

    onDetailTableChange = (redeemtion, pagination, filters, sorter) => {
        let currentFilters = {groupId: redeemtion.groupId, ...omit(redeemtion.detail, ['items', 'orderBy', 'orderByDesc'])}
        filters = omit({ ...currentFilters, ...filters }, ['pageSize', 'pageIndex', 'totalCount', 'totalPage']);
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.props.getVoucherRedeemtionReportDetail(newFilters);
    }

    onItemExpanded = (expanded, redeemtion) => {
        const filters = {groupId: redeemtion.groupId, ...omit(redeemtion.detail, ['items'])}
        this.props.getVoucherRedeemtionReportDetail(filters);
    }

    getCurrentFilters = (removeFields) => {
        const { reportState: { voucherRedeemReport } } = this.props;
        const filters = omit(voucherRedeemReport, ['voucherRedeemtions']);
        return removeFields ? omit(filters, removeFields) : filters;
    }

    collapseAllRow = () => {
        if(this.redeemtionListRef && this.redeemtionListRef.current){
            this.redeemtionListRef.current.collapseAllRow();
        }
    }

    onExportExcel = () => {
        const filters = this.getCurrentFilters(['totalCount', 'totalPage'])
        this.props.exportExcel(filters);
    }

}

VoucherRedeemtionReports.defaultProps = {
}
